<template>
  <div class="payment-cards">
    <transition name="fade" mode="out-in">
      <loader-with-message v-if="isPaymentCardLoading"
                           :has-error="paymentCardsDataFetchError"
                           @retry="fetchPaymentCards" />
      <div v-if="paymentCards.length > 0"
           :key="'cards'">
        <base-heading :underline="false">
          {{ $t('paymentCards.pageTitle') }}
        </base-heading>
        <div class="cards-container">
          <single-payment-card v-for="card in paymentCards"
                               :key="card.code"
                               :card-name="card.type"
                               :card-number="card.cardNumber"
                               :card-date="card.expirationDate"
                               :card-code="card.code"
                               @delete-card="openDeleteConfirmation"/>
        </div>
        <p class="note">{{ $t('paymentCards.addCardsNote') }}</p>
        <base-button variant="primary"
                     @click="addCard"
                     :disabled="isCardBeingAdded">
          {{ $t('paymentCards.addCard') }}
        </base-button>
      </div>
      <no-payment-cards v-else-if="!paymentCards.length && noCardsAvailable"
                        :key="'no-cards'"
                        @add-card="addCard"/>
    </transition>
    <bank-form :form-data="bankFormData" ref="bankForm"/>
    <confirmation-modal :visible="confirmDeleteModalVisible"
                        @close="confirmDeleteModalVisible = false"
                        confirm-type="warning"
                        :confirm-title="$t('deletePaymentCard.confirmation.title')"
                        :confirm-description="$t('deletePaymentCard.confirmation.description')"
                        :confirm-text="$t('deletePaymentCard.confirmation.confirmButton')"
                        :button-disabled="deleteInProgress"
                        @confirm="deleteCard"/>
  </div>
</template>

<script>
import SinglePaymentCard from '@/components/common/payment-cards/single-payment-card'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import NoPaymentCards from '@/components/common/payment-cards/no-payment-cards'
import BankForm from '@/components/common/payment-cards/bank-form'
import ConfirmationModal from '@/components/common/modal/confirmation-modal'
import LoaderWithMessage from '@/components/common/loader-with-message'

export default {
  name: 'user-payment-cards',
  components: { LoaderWithMessage, ConfirmationModal, BankForm, NoPaymentCards, SinglePaymentCard },
  data () {
    return {
      isPaymentCardLoading: false,
      paymentCardsDataFetchError: false,
      paymentCards: [],
      noCardsAvailable: false,
      isCardBeingAdded: false,
      confirmDeleteModalVisible: false,
      cardToDelete: '',
      bankFormData: {},
      deleteInProgress: false
    }
  },
  mixins: [errorMessageHandler],
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    fetchPaymentCards () {
      this.isPaymentCardLoading = true
      this.paymentCardsDataFetchError = false
      this.$apiRequest.post('user/payment/cards')
        .then(response => {
          this.paymentCards = response.data.cards
          if (!this.paymentCards.length) this.noCardsAvailable = true
          this.isPaymentCardLoading = false
        })
        .catch(e => {
          this.paymentCardsDataFetchError = true
          // this.handleErrorMessage(e.response.data)
          // this.noCardsAvailable = true
        })
    },
    addCard () {
      this.isCardBeingAdded = true

      this.$apiRequest.post('user/payment/authform')
        .then(response => {
          this.bankFormData = response.data
          setTimeout(() => {
            this.$refs.bankForm.$refs.submitButton.click()
          }, 100)
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
          this.isCardBeingAdded = false
        })
    },
    openDeleteConfirmation (code) {
      this.cardToDelete = code
      this.confirmDeleteModalVisible = true
      this.deleteInProgress = false
    },
    deleteCard () {
      this.deleteInProgress = true
      this.$apiRequest.delete(`user/payment/cards?code=${this.cardToDelete}`)
        .then(() => {
          this.paymentCards = []
          this.toast('success', {
            title: this.$t('deletePaymentCard.successToastTitle'),
            message: this.$t('deletePaymentCard.successToastMessage')
          })
          this.fetchPaymentCards()
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.handleDeleteConfirmationClose()
        })
    },
    handleDeleteConfirmationClose () {
      this.cardToDelete = ''
      this.confirmDeleteModalVisible = false
    }
  },
  created () {
    this.fetchPaymentCards()
  }
}
</script>

<style scoped lang="scss">
.payment-cards {
  padding-top: 2rem;
}

.cards-container {
  margin-bottom: 1.6rem;
}

.note {
  font-size: 1.2rem;
  color: $dark-grey;
  margin-bottom: 2.4rem;
}
</style>
